import { Component, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../../../modules/employee/class/user';
import { LoginService } from '../../../modules/employee/service/login/login.service';
import { AccountService } from '../../../modules/employee/service/account/account.service';

@Component({
  selector: 'app-clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.scss']
})
export class ClockComponent implements OnInit {

    public clock: any;
    public name: String;

    constructor(
        public loginService: LoginService,
        private accountService: AccountService
        ) {
    }

    ngOnInit() {
        setInterval(() => {
            this.clock = new Date();
        }, 1000);

        // this.name = JSON.parse(localStorage.getItem('profile')).employee.name;
        this.name = '';
        this.getAccount();
    }

    public getAccount() {
        if ( this.loginService.loggedIn() ) {
            const profile = JSON.parse(localStorage.getItem('profile'));
            if (profile.employee)
                this.name = profile.employee.name;
            else
                this.name = profile.candidate.name;
            
            // this.name = this.capitalize(this.name);
        }
    }

    public capitalize(sentence) {
        sentence = sentence.toLowerCase();
        sentence = sentence.split(' ');

        for (var i = 0; i < sentence.length; i++)
            sentence[i] = sentence[i][0].toUpperCase() + sentence[i].substring(1);

        sentence = sentence.join(' ');

        return sentence;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/clock/clock.component.ts